import { type TimeScalar } from '@bts-web/utils-formatting';
import { TransactionDetailsFieldVariants } from '../TransactionDetailsField/TransactionDetailsField';
import type { DetailEntity } from './types';

type OptionalTimeFieldProps = [
  label: string,
  name: string,
  value: TimeScalar | null | undefined,
  variant:
    | TransactionDetailsFieldVariants.TRANSACTION_DATE
    | TransactionDetailsFieldVariants.TRANSACTION_DATE_HOUR,
];

export const optionalTimeFields = (
  ...props: OptionalTimeFieldProps
): DetailEntity[] => {
  const field = optionalTimeField(props);

  return field ? [field] : [];
};

const optionalTimeField = ([
  label,
  name,
  value,
  variant,
]: OptionalTimeFieldProps): DetailEntity | null => {
  if (value == null) {
    return null;
  }

  const kind =
    variant === TransactionDetailsFieldVariants.TRANSACTION_DATE
      ? 'date-only'
      : 'date-hour';

  return {
    kind,
    label,
    name,
    value,
  };
};
